/* eslint-disable react/require-default-props */
import React from 'react';
import { AiManagementCard, AiManagementColumn } from 'store/modules/ai_management_store/types';
import AiManagementAvatar from 'components/atoms/ai_management_avatar';
import AiManagementCardMenu from 'components/molecules/ai_management_card_menu';

interface AiManagementCardModalTopbarProps {
  card: AiManagementCard;
  column?: AiManagementColumn;
  onOpenMembers: () => void;
  onClose: () => void;
}

const AiManagementCardModalTopbar: React.FC<AiManagementCardModalTopbarProps> = ({
  card,
  column,
  onOpenMembers,
  onClose,
}) => {
  const { bidding } = card;

  const info = [
    { icon: 'account_balance', text: bidding.public_body },
    { icon: 'place', text: `${bidding.city} - ${bidding.state}` },
    { icon: 'confirmation_number', text: `Nº Conlicitação: ${card.bidding_id}` },
  ];

  return (
    <div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
      <div>
        <div className="d-flex align-items-center flex-wrap mb-1">
          <h5 className="mb-0 mr-2 font-weight-bold">Licitação {bidding.notice_number}</h5>
          {column && (
            <span className="badge text-white" style={{ backgroundColor: column.color }}>
              {column.name}
            </span>
          )}
        </div>
        <div className="d-flex align-items-center flex-wrap">
          {info.map((item) => (
            <span key={item.icon} className="text-muted small mr-3 d-flex align-items-center">
              <i className="material-icons mr-1">{item.icon}</i>
              {item.text}
            </span>
          ))}
          <span className="d-flex align-items-center">
            <span className="text-muted small mr-2">Membros:</span>
            {card.members.map((member) => (
              <AiManagementAvatar
                key={member.id}
                initials={member.initials}
                memberId={member.id}
                name={member.name}
                balloonPosition="down"
              />
            ))}
          </span>
        </div>
      </div>

      <div className="d-flex align-items-center">
        <AiManagementCardMenu
          ariaLabel="Opções da licitação"
          items={[
            { label: 'Alterar membros', onClick: onOpenMembers },
            { label: 'Alterar status', onClick: () => {} },
          ]}
        />
        <button
          type="button"
          className="btn btn-link text-dark p-0 d-flex align-items-center ml-1"
          aria-label="Fechar"
          onClick={onClose}
        >
          <i className="material-icons">close</i>
        </button>
      </div>
    </div>
  );
};

export default AiManagementCardModalTopbar;
